
// import { useState } from 'react';
// import ReferralCard from './components/ReferralCard';
// import RewardStats from './components/RewardStats';
// import HowItWorks from './components/HowItWorks';
// import ReferralHistory from './components/ReferralHistory';
// import Leaderboard from './components/Leaderboard';
// import Navbar from '../../components/feature/Navbar';
// import MobileBottomNav from '../../components/feature/MobileBottomNav';

// export default function Rewards() {
//   const [activeTab, setActiveTab] = useState('overview');

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-navy-50 via-white to-cyan-50">
//       <Navbar />

//       <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-8 pb-24 md:pb-8">
//         {/* Header */}
//         <div className="mb-4 md:mb-6">
//           <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1 md:mb-2">Rewards &amp; Referrals</h1>
//           <p className="text-sm md:text-base text-gray-600">Invite friends and earn rewards together</p>
//         </div>

//         {/* Tab Switcher */}
//         <div className="bg-white rounded-xl shadow-sm p-1 mb-5 flex">
//           <button
//             onClick={() => setActiveTab('overview')}
//             className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
//               activeTab === 'overview' ? 'bg-navy-600 text-white' : 'text-gray-600 hover:text-gray-900'
//             }`}
//           >
//             <i className="ri-gift-line mr-1.5"></i>
//             Overview
//           </button>
//           <button
//             onClick={() => setActiveTab('history')}
//             className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
//               activeTab === 'history' ? 'bg-navy-600 text-white' : 'text-gray-600 hover:text-gray-900'
//             }`}
//           >
//             <i className="ri-history-line mr-1.5"></i>
//             History
//           </button>
//           <button
//             onClick={() => setActiveTab('leaderboard')}
//             className={`flex-1 px-3 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
//               activeTab === 'leaderboard' ? 'bg-navy-600 text-white' : 'text-gray-600 hover:text-gray-900'
//             }`}
//           >
//             <i className="ri-trophy-line mr-1.5"></i>
//             Leaderboard
//           </button>
//         </div>

//         {/* Overview Tab */}
//         {activeTab === 'overview' && (
//           <div className="space-y-5">
//             <ReferralCard />
//             <RewardStats />
//             <HowItWorks />

//             {/* Reward Tiers */}
//             <div className="bg-white rounded-xl shadow-sm p-5 md:p-7">
//               <h3 className="text-base md:text-lg font-semibold text-gray-900 mb-4">Reward Tiers</h3>
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
//                 {[
//                   { tier: 'Bronze', min: 0, max: 10, reward: '₦200/ref', color: 'from-orange-100 to-amber-50', border: 'border-orange-200', icon: 'text-orange-500', current: false },
//                   { tier: 'Silver', min: 10, max: 50, reward: '₦300/ref', color: 'from-gray-100 to-slate-50', border: 'border-gray-300', icon: 'text-gray-500', current: true },
//                   { tier: 'Gold', min: 50, max: 100, reward: '₦500/ref', color: 'from-amber-100 to-yellow-50', border: 'border-amber-300', icon: 'text-amber-500', current: false },
//                   { tier: 'Platinum', min: 100, max: null, reward: '₦1,000/ref', color: 'from-navy-100 to-cyan-50', border: 'border-navy-300', icon: 'text-navy-600', current: false },
//                 ].map((t, i) => (
//                   <div key={i} className={`relative bg-gradient-to-br ${t.color} border ${t.border} rounded-xl p-4 ${t.current ? 'ring-2 ring-navy-500' : ''}`}>
//                     {t.current && (
//                       <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-navy-600 text-white text-xs font-medium px-2.5 py-0.5 rounded-full whitespace-nowrap">
//                         Current Tier
//                       </span>
//                     )}
//                     <div className="w-8 h-8 flex items-center justify-center mb-2">
//                       <i className={`ri-medal-line text-2xl ${t.icon}`}></i>
//                     </div>
//                     <h4 className="font-bold text-gray-900 text-sm">{t.tier}</h4>
//                     <p className="text-xs text-gray-500 mt-0.5 mb-2">
//                       {t.max ? `${t.min}–${t.max} referrals` : `${t.min}+ referrals`}
//                     </p>
//                     <p className="text-sm font-semibold text-gray-900">{t.reward}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         )}

//         {/* History Tab */}
//         {activeTab === 'history' && <ReferralHistory />}

//         {/* Leaderboard Tab */}
//         {activeTab === 'leaderboard' && <Leaderboard />}
//       </main>

//       <MobileBottomNav />
//     </div>
//   );
// }







// import { motion } from "framer-motion";
// import { FaTrophy, FaCopy, FaWhatsapp, FaTelegram, FaFacebook, FaTwitter, FaInstagram, FaShare } from "react-icons/fa";
// import { useState } from "react";
// import { ArrowBigLeft, TrophyIcon } from "lucide-react";

// import MobileBottomNav from "../../components/feature/MobileBottomNav";
// import rew from '../../assets/images/rewardimg.png';
// export default function RewardHome() {
//   const [copied, setCopied] = useState(false);

//   const referralCode = "UMO-928372";

//   const handleCopy = () => {
//     navigator.clipboard.writeText(referralCode);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   return (
//     <>
//     <motion.div
//       initial={{ opacity: 0, y: 40 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0 }}
//       transition={{ duration: 0.3 }}
//       className="min-h-screen bg-gray-50 px-4 pt-6 pb-24"
//     >
//       {/* Header */}
//       <a href="/">
//         <h1 className="text-lg font-semibold text-start flex items-center mb-6">
//         ← Reward
//       </h1>
//       </a>

//       {/* Balance Card */}
//       <div className="bg-white rounded-2xl shadow-md p-5 relative">
//         <div className="flex justify-between items-center">
//           <h2 className="text-gray-500 text-sm">Available Balance</h2>
//           <FaTrophy className="text-yellow-500 text-2xl absolute bottom-5 right-2 " />
//         </div>

//         <p className="text-3xl font-bold mt-2">₦50.00</p>
//       </div>

//       {/* Referral Banner */}
//       <motion.div
//         whileHover={{ scale: 1.02 }}
//         className="bg-[#101B36] text-white rounded-2xl flex gap-2 p-2 mt-6 shadow-md"
//       >
//         {/* <div className="mt-3">
//           <TrophyIcon/>
//         </div>
//         <div>
//           <p className="font-semibold">
//           Invite friends and earn rewards 🎉
//         </p>
//         <p className="text-sm mt-1 opacity-90">
//           Share your referral code and earn bonuses when they sign up.
//         </p> */}
//         {/* </div> */}
//         <img src={rew} alt="" />
//       </motion.div>

    

//       {/* Referral Code */}
//       <div className="bg-white rounded-2xl shadow-md p-4 mt-6">
//         <p>Number of Invites 2</p>
//         <p className="text-gray-500 text-sm text-center mt-10">Your Ref Code</p>

//         <div className="flex items-center justify-between mt-3 gap-3 rounded-xl px-1 py-2">
//          <div className="bg-gray-100 py-2 w-full rounded-full p-1">
//            <span className="font-semibold tracking-wider p-2">
//             {referralCode}
//           </span>
//          </div>

//           <div className="border border-gray-500 p-2 rounded-full">
//             <button
//             onClick={handleCopy}
//             className="text-blue-600 flex items-center gap-1 text-sm"
//           >
//             <FaCopy />
           
//           </button>
//           </div>
//         </div>

//         {/* Social Share */}
//         <div className="text-center mt-4">
//           <h1>Share with</h1>
//         </div>
//         <div className="flex justify-center gap-6 mt-6 text-xl text-gray-600">
//           <FaWhatsapp size={30} className="hover:text-green-500 cursor-pointer" />
//           <FaTwitter className="hover:text-blue-500 cursor-pointer" size={30}/>
//           <FaInstagram className="hover:text-blue-700 cursor-pointer" size={30}/>
//           <FaShare className="hover:text-blue-700 cursor-pointer" size={30}/>
//         </div>
//       </div>
//     </motion.div>
//     <MobileBottomNav/>
//     </>
//   );
// }




// import { motion } from "framer-motion";
// import {
//   FaTrophy,
//   FaCopy,
//   FaWhatsapp,
//   FaTwitter,
//   FaInstagram,
//   FaShare,
// } from "react-icons/fa";
// import { useState, useEffect } from "react";

// import { apiClient } from "../../api/apiServices";

// import MobileBottomNav from "../../components/feature/MobileBottomNav";
// import rew from "../../assets/images/rewardimg.png";

// export default function RewardHome() {
//   const [copied, setCopied] = useState(false);
//   const [referralCode, setReferralCode] = useState("");
//   const [referralLink, setReferralLink] = useState("");
//   const [totalReferrals, setTotalReferrals] = useState(0);
//   const [balance, setBalance] = useState(0);

//   useEffect(() => {
//     fetchWallet();
//     fetchReferralSummary();
//   }, []);

//   const fetchWallet = async () => {
//     try {
//       const res = await apiClient.get("/wallet");
//       setBalance(res.data.balance);
//     } catch (error) {
//       console.error("Wallet error:", error);
//     }
//   };

//   const fetchReferralSummary = async () => {
//     try {
//       const res = await apiClient.get("/referrals/summary");

//       setReferralCode(res.data.referralCode);
//       setReferralLink(res.data.referralLink);
//       setTotalReferrals(res.data.totalReferrals);
//     } catch (error) {
//       console.error("Referral summary error:", error);
//     }
//   };

//   const handleCopy = () => {
//     navigator.clipboard.writeText(referralLink);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   const shareText = `Join me on Databling and earn rewards! ${referralLink}`;

//   const shareWhatsApp = () => {
//     window.open(
//       `https://wa.me/?text=${encodeURIComponent(shareText)}`,
//       "_blank"
//     );
//   };

//   const shareTwitter = () => {
//     window.open(
//       `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`,
//       "_blank"
//     );
//   };

//   const shareInstagram = () => {
//     navigator.clipboard.writeText(referralLink);
//     alert("Referral link copied. Paste it on Instagram.");
//   };

//   const shareNative = () => {
//     if (navigator.share) {
//       navigator.share({
//         title: "Join Databling",
//         text: "Use my referral link",
//         url: referralLink,
//       });
//     } else {
//       navigator.clipboard.writeText(referralLink);
//       alert("Referral link copied!");
//     }
//   };

//   return (
//     <>
//       <motion.div
//         initial={{ opacity: 0, y: 40 }}
//         animate={{ opacity: 1, y: 0 }}
//         exit={{ opacity: 0 }}
//         transition={{ duration: 0.3 }}
//         className="min-h-screen bg-gray-50 px-4 pt-6 pb-24"
//       >
//         <a href="/">
//           <h1 className="text-lg font-semibold text-start flex items-center mb-6">
//             ← Reward
//           </h1>
//         </a>

//         {/* Balance */}
//         <div className="bg-white rounded-2xl shadow-md p-5 relative">
//           <div className="flex justify-between items-center">
//             <h2 className="text-gray-500 text-sm">Available Balance</h2>
//             <FaTrophy className="text-yellow-500 text-2xl absolute bottom-5 right-2" />
//           </div>

//           <p className="text-3xl font-bold mt-2">₦{balance}</p>
//         </div>

//         {/* Banner */}
//         <motion.div
//           whileHover={{ scale: 1.02 }}
//           className="bg-[#101B36] text-white rounded-2xl flex gap-2 p-2 mt-6 shadow-md"
//         >
//           <img src={rew} alt="" />
//         </motion.div>

//         {/* Referral */}
//         <div className="bg-white rounded-2xl shadow-md p-4 mt-6">
//           <p>Number of Invites {totalReferrals}</p>

//           <p className="text-gray-500 text-sm text-center mt-10">
//             Your Ref Code
//           </p>

//           <div className="flex items-center justify-between mt-3 gap-3 rounded-xl px-1 py-2">
//             <div className="bg-gray-100 py-2 w-full rounded-full p-1">
//               <span className="font-semibold tracking-wider p-2">
//                 {referralCode}
//               </span>
//             </div>

//             <div className="border border-gray-500 p-2 rounded-full">
//               <button
//                 onClick={handleCopy}
//                 className="text-blue-600 flex items-center gap-1 text-sm"
//               >
//                 <FaCopy />
//               </button>
//             </div>
//           </div>

//           {/* Share */}
//           <div className="text-center mt-4">
//             <h1>Share with</h1>
//           </div>

//           <div className="flex justify-center gap-6 mt-6 text-xl text-gray-600">
//             <FaWhatsapp
//               size={30}
//               onClick={shareWhatsApp}
//               className="hover:text-green-500 cursor-pointer"
//             />

//             <FaTwitter
//               size={30}
//               onClick={shareTwitter}
//               className="hover:text-blue-500 cursor-pointer"
//             />

//             <FaInstagram
//               size={30}
//               onClick={shareInstagram}
//               className="hover:text-pink-500 cursor-pointer"
//             />

//             <FaShare
//               size={30}
//               onClick={shareNative}
//               className="hover:text-blue-700 cursor-pointer"
//             />
//           </div>
//         </div>
//       </motion.div>

//       <MobileBottomNav />
//     </>
//   );
// }





import { motion } from "framer-motion";
import {
  FaTrophy,
  FaCopy,
  FaWhatsapp,
  FaTwitter,
  FaInstagram,
  FaShare,
} from "react-icons/fa";
import { useState, useEffect } from "react";

import { apiClient, getCashbackBalance } from "../../api/apiServices";

import MobileBottomNav from "../../components/feature/MobileBottomNav";
import rew from "../../assets/images/rewardimg.png";

export default function RewardHome() {
  const [copied, setCopied] = useState(false);
  const [referralCode, setReferralCode] = useState("");
  const [referralLink, setReferralLink] = useState("");
  const [totalReferrals, setTotalReferrals] = useState(0);
  const [balance, setBalance] = useState(0);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchReferrals();
    fetchReferralSummary();
    loadCashbackData()
  }, []);

  // Get referrals list
  const fetchReferrals = async () => {
    try {
      const res = await apiClient.get("/referrals");

      if (Array.isArray(res.data)) {
        setTotalReferrals(res.data.length);
      }
    } catch (error) {
      console.error("Referrals error:", error);
    }
  };

  // Get referral summary
  const fetchReferralSummary = async () => {
    try {
      const res = await apiClient.get("/referrals/summary");

      setReferralCode(res.data.referralCode || "");
      setReferralLink(res.data.referralLink || "");
      setTotalReferrals(res.data.totalReferrals || 0);
    } catch (error) {
      console.error("Referral summary error:", error);
    }
  };

  const loadCashbackData = async () => {
    try {
      setError(null);
      const  cashbackRes = await getCashbackBalance()
      setBalance(cashbackRes?.cashbackBalance);
    } catch (err) {
      console.error("Failed to load referral data:", err);
      setError("Could not load reward data. Please try again.");
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareText = `Join me on Databling and earn rewards! ${referralLink}`;

  const shareWhatsApp = () => {
    window.open(
      `https://wa.me/?text=${encodeURIComponent(shareText)}`,
      "_blank"
    );
  };

  const shareTwitter = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`,
      "_blank"
    );
  };

  const shareInstagram = () => {
    navigator.clipboard.writeText(referralLink);
    alert("Referral link copied. Paste it on Instagram.");
  };

  const shareNative = () => {
    if (navigator.share) {
      navigator.share({
        title: "Join Databling",
        text: "Use my referral link",
        url: referralLink,
      });
    } else {
      navigator.clipboard.writeText(referralLink);
      alert("Referral link copied!");
    }
  };

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="min-h-screen bg-gray-50 px-4 pt-6 pb-24"
      >
        <a href="/">
          <h1 className="text-lg font-semibold text-start flex items-center mb-6">
            ← Reward
          </h1>
        </a>

        {/* Balance */}
        <div className="bg-white rounded-2xl shadow-md p-5 relative">
          <div className="flex justify-between items-center">
            <h2 className="text-gray-500 text-sm">Available Balance</h2>
            <FaTrophy className="text-yellow-500 text-2xl absolute bottom-5 right-2" />
          </div>

          <p className="text-3xl font-bold mt-2">₦{balance}</p>
        </div>

        {/* Banner */}
        <motion.div
          whileHover={{ scale: 1.02 }}
          className="bg-[#101B36] text-white rounded-2xl flex gap-2 p-2 mt-6 shadow-md"
        >
          <img src={rew} alt="" />
        </motion.div>

        {/* Referral */}
        <div className="bg-white rounded-2xl shadow-md p-4 mt-6">
          <p>Number of Invites {totalReferrals}</p>

          <p className="text-gray-500 text-sm text-center mt-10">
            Your Ref Code
          </p>

          <div className="flex items-center justify-between mt-3 gap-3 rounded-xl px-1 py-2">
            <div className="bg-gray-100 py-2 w-full rounded-full p-1">
              <span className="font-semibold tracking-wider p-2">
                {referralCode}
              </span>
            </div>

            <div className="border border-gray-500 p-2 rounded-full">
              <button
                onClick={handleCopy}
                className="text-blue-600 flex items-center gap-1 text-sm"
              >
                <FaCopy />
              </button>
            </div>
          </div>

          {/* Share */}
          <div className="text-center mt-4">
            <h1>Share with</h1>
          </div>

          <div className="flex justify-center gap-6 mt-6 text-xl text-gray-600">
            <FaWhatsapp
              size={30}
              onClick={shareWhatsApp}
              className="hover:text-green-500 cursor-pointer"
            />

            <FaTwitter
              size={30}
              onClick={shareTwitter}
              className="hover:text-blue-500 cursor-pointer"
            />

            <FaInstagram
              size={30}
              onClick={shareInstagram}
              className="hover:text-pink-500 cursor-pointer"
            />

            <FaShare
              size={30}
              onClick={shareNative}
              className="hover:text-blue-700 cursor-pointer"
            />
          </div>
        </div>
      </motion.div>

      <MobileBottomNav />
    </>
  );
}